import { render, staticRenderFns } from "./ChoAnswer.vue?vue&type=template&id=f01fa2d0&scoped=true&"
import script from "./ChoAnswer.vue?vue&type=script&lang=js&"
export * from "./ChoAnswer.vue?vue&type=script&lang=js&"
import style0 from "./ChoAnswer.vue?vue&type=style&index=0&id=f01fa2d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01fa2d0",
  null
  
)

export default component.exports